import { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import Auth from "../services/auth";
import { useQuery } from "../common/Hooks";
import LandingPage from "./components/LandingPage";
import TextBox from "../components/controls/form/TextBox";

const ResetPassword = () => {
    const query = useQuery();
    const [translate] = useTranslation();

    const [resetEmailSent, setResetEmailSent] = useState(false);

    const resetPassword = useCallback(async ({ email }) => {
        const res = await Auth.resetPassword({ email });

        if (!res.error) {
            setResetEmailSent(true);
        }
    }, []);

    return (
        <LandingPage>
            <div className="row mt-n2">
                {resetEmailSent ? (
                    <div className="col-12 mt-2 text-center">
                        {translate("OTM_RESET_PASSWORD_SENT")}
                    </div>
                ) : (
                    <>
                        <div className="col-12 mt-2 text-center">
                            {translate("OTM_RESET_PASSWORD_CONFIRMATION")}
                        </div>
                        <Formik
                            initialValues={{
                                email: query.get("email") || window.localStorage.getItem("email") || ""
                            }}
                            validationSchema={Yup.object({
                                email: Yup.string()
                                    .email(translate("OTM_INVALID_EMAIL"))
                                    .required(" ")
                            })}
                            onSubmit={resetPassword}
                        >
                            <Form className="col-12 mt-2 text-center">
                                <TextBox
                                    placeholder={translate("OTM_EMAIL")}
                                    type="email"
                                    name="email"
                                />
                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="mt-2"
                                >
                                    {translate("OTM_RESET_PASSWORD_SUBMIT")}
                                </Button>
                            </Form>
                        </Formik>

                    </>
                )}
                <div className="col-12 mt-2">
                    <Link to="/auth">
                        {translate("OTM_RESET_PASSWORD_RETURN_TO_LOGIN")}
                    </Link>
                </div>
            </div>
        </LandingPage>
    );
};

export default ResetPassword;
